import { MTSort, SortDirection } from "@services/getMinerList";
import { FormValues } from "@utils/getFormValue";

import {
  ActionTypesMinersTable,
  ActionBaseMinersTable,
  ActionSetPage,
  ActionSetState,
  ActionTempSavePageSize,
  ActionSetSort,
  ActionSetAdminOnlyFlag,
} from "./actionTypes";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from "@components/Pages/Machines/MinersTable/useMinersTableControl";

interface MinersTableOptions {
  IsAdminOnly: boolean;
}
interface MinersTableState {
  Page: number;
  PageSize: number;
  Filters?: FormValues;
  Options?: MinersTableOptions;
  sort: [MTSort, SortDirection];
}

const initialState: MinersTableState = {
  Page: DEFAULT_PAGE,
  PageSize: DEFAULT_PAGE_SIZE,
  sort: [MTSort.Unset, SortDirection.Unset],
  Options: {
    IsAdminOnly: false,
  },
};

const minersTableReducer = (
  state: MinersTableState = initialState,
  action: ActionBaseMinersTable
): MinersTableState => {
  switch (action.type) {
    // case ActionTypesMinersTable.SET_FILTERS: {
    //   const act = action as ActionSetFilters;
    //   return { ...state, Filters: act.payload };
    // }
    case ActionTypesMinersTable.CLEAN_STATE:
      return initialState;
    case ActionTypesMinersTable.SET_PAGE: {
      const act = action as ActionSetPage;
      return {
        ...state,
        Page: act.payload.Page,
        PageSize: act.payload.PageSize,
      };
    }
    case ActionTypesMinersTable.SET_STATE: {
      const act = action as ActionSetState;
      return {
        ...state,
        Page: act.payload.Page,
        PageSize: act.payload.PageSize,
      };
    }
    case ActionTypesMinersTable.SET_SORT: {
      const act = action as ActionSetSort;
      return {
        ...state,
        sort: act.payload.sort,
      };
    }
    case ActionTypesMinersTable.TEMP_SAVE_PAGE_SIZE: {
      const act = action as ActionTempSavePageSize;
      return { ...state, PageSize: act.payload };
    }
    case ActionTypesMinersTable.SET_ADMIN_ONLY_SUMMARY_CHART_FLAG: {
      const act = action as ActionSetAdminOnlyFlag;
      return {
        ...state,
        Options: { ...state.Options, IsAdminOnly: act.payload },
      };
    }

    default:
      return state;
  }
};

export default minersTableReducer;
